export default "__VITE_ASSET__76682305__"